import { Routes } from '@angular/router';
import { UsuariosLista } from '@/features/configuracoes/usuario/usuarios-lista/usuarios-lista';
import { Permissoes } from '@/features/configuracoes/usuario/permissoes/permissoes';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';
import { MotivoAfastamento } from '@/features/configuracoes/usuario/motivo-afastamento/motivo-afastamento';
import { CONFIGURACOES_USUARIO_ROUTES } from './configuracoes-usuario.constants';

/** Rotas das Configurações de Usuários (cadastro, permissões e motivos de afastamento). */
export const configuracoesUsuarioRoutes: Routes = [
    {
        path: CONFIGURACOES_USUARIO_ROUTES.ROOT,
        data: { breadcrumb: 'Usuários' },
        children: [
            { path: '', redirectTo: CONFIGURACOES_USUARIO_ROUTES.CADASTRO, pathMatch: 'full' },
            { path: CONFIGURACOES_USUARIO_ROUTES.CADASTRO, component: UsuariosLista, data: { breadcrumb: 'Cadastro' } },
            {
                path: CONFIGURACOES_USUARIO_ROUTES.PERMISSOES,
                component: Permissoes,
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Permissões', permission: PERMISSOES.configuracoes.usuarios.permissoes.administrar }
            },
            { path: CONFIGURACOES_USUARIO_ROUTES.MOTIVO_AFASTAMENTO, component: MotivoAfastamento, data: { breadcrumb: 'Motivo de Afastamento' } }
        ]
    }
];

export default configuracoesUsuarioRoutes;
